var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { CONFIG } from "../../config/app.config";
import api from "../../utils/api/api.utils";
import { appendFilter } from "../../utils/api.utils";
import { mapObjectWithTimeZonedDatesToUtcIsoString } from "../../utils/date.utils";
import { appendQueryParams } from "../../utils/url.utils";
export var getContacts = function (skip, limit, filterData) {
    if (limit === void 0) { limit = CONFIG.DEFAULT_FETCH_LIMIT; }
    if (filterData === void 0) { filterData = {}; }
    var filter = __assign({ order: ["lastname ASC", "firstname ASC", "createdAt DESC"], limit: limit, skip: skip }, filterData);
    return api.get(appendFilter("/contacts", filter));
};
export var getContact = function (id) {
    return api.get("/contacts/".concat(id));
};
export var getContactsByAccountIds = function (ids) {
    return api.get(appendFilter("/contacts", {
        where: { accountIds: { inq: ids } },
    }));
};
export var getContactSupport = function () {
    return api.get(appendFilter("/contacts", { where: { type: "S" } }));
};
export var searchContacts = function (query, extraFilterData) {
    if (extraFilterData === void 0) { extraFilterData = {}; }
    var filter = __assign(__assign({ order: ["lastname ASC", "firstname ASC", "createdAt DESC"], limit: 30 }, extraFilterData), { search: query });
    return api.get(appendFilter("/contacts", filter));
};
export var createContact = function (data, sendInvite) {
    if (sendInvite === void 0) { sendInvite = false; }
    return api.post("/contacts?sendInvite=".concat(sendInvite), {
        data: mapObjectWithTimeZonedDatesToUtcIsoString(data, false),
    });
};
// The contact forms build a V1-shaped payload (lowercase firstname/lastname, plus
// `baseAccountId` and a `country` duplicate of `countryId` that no contact column backs).
// V2 takes camelCase and rejects unknown properties, so translate at the boundary rather
// than reshaping the shared form mapper, which still feeds the V1 contact endpoints.
var toV2ContactPayload = function (contact) {
    var _a = contact, firstname = _a.firstname, lastname = _a.lastname, _baseAccountId = _a.baseAccountId, _country = _a.country, rest = __rest(_a, ["firstname", "lastname", "baseAccountId", "country"]);
    return mapObjectWithTimeZonedDatesToUtcIsoString(__assign(__assign(__assign({}, rest), (firstname === undefined ? {} : { firstName: firstname })), (lastname === undefined ? {} : { lastName: lastname })), false);
};
export var createContactBroker = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var response;
    var brokerId = _b.brokerId, customId = _b.customId, contact = _b.contact;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, api.post("/brokers/".concat(brokerId, "/contact/").concat(customId), { data: toV2ContactPayload(contact), isV2: true })];
            case 1:
                response = _c.sent();
                return [2 /*return*/, __assign(__assign({}, response), { data: response.data.data })];
        }
    });
}); };
export var updateContact = function (id, data) {
    return api.patch("/contacts/".concat(id), {
        data: mapObjectWithTimeZonedDatesToUtcIsoString(data, false),
    });
};
export var breakUserConnection = function (id) {
    return api.delete("/contacts/".concat(id, "/unlink-connection"), { isV2: true });
};
// The KBO/BCE is only reachable from the backend, so the dashboard asks the
// Rentio API for the company data instead of calling the register itself.
export var getContactExternalInfo = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/contacts/".concat(id, "/get-external-info"), { isServerless: true })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result.data];
        }
    });
}); };
export var kycContact = function (id, presignedUrlIdCardFront, presignedUrlIdCardBack, asBroker, bankAccountId) {
    if (asBroker === void 0) { asBroker = false; }
    var path = asBroker
        ? "/broker-kyc/".concat(id).concat(bankAccountId ? "?bankAccountId=".concat(bankAccountId) : "")
        : "/contacts/".concat(id, "/kyc");
    return api.post(path, {
        isServerless: true,
        data: {
            uploadMethod: "presigned",
            IDCardFrontside: { preSignedUrl: presignedUrlIdCardFront },
            IDCardBackside: { preSignedUrl: presignedUrlIdCardBack },
        },
    });
};
// DEV-2801: Mangopay's hosted identity verification (IDV) of a contact, a KYB for a legal user and an IDV KYC
// for a natural user. A broker uses it for its contacts (broker-kyc-idv), a user for its own contact
// (contacts/{id}/kyc-idv), like broker-kyc and contacts/{id}/kyc.
var getKycIdvPath = function (contactId, asBroker) {
    return asBroker ? "/broker-kyc-idv/".concat(contactId) : "/contacts/".concat(contactId, "/kyc-idv");
};
// The kind of Mangopay user the contact is, the company it verifies, Rentio's result and the latest session
export var getKycIdv = function (contactId, asBroker) {
    if (asBroker === void 0) { asBroker = true; }
    return api.get(getKycIdvPath(contactId, asBroker), {
        isServerless: true,
    });
};
// The hosted session: the still-valid one when there is one, otherwise a new one. returnUrl: the page Mangopay
// sends the user back to afterwards.
export var startKycIdv = function (contactId, params) {
    var _a;
    if (params === void 0) { params = {}; }
    return api.post(getKycIdvPath(contactId, (_a = params.asBroker) !== null && _a !== void 0 ? _a : true), { isServerless: true, data: { returnUrl: params.returnUrl } });
};
export var getScaUrl = function (params) {
    var contactId = params.contactId, redirectUrl = params.redirectUrl, bankAccountId = params.bankAccountId;
    var path = appendQueryParams({
        path: "/sca/".concat(contactId),
        queryParams: {
            bankAccountId: bankAccountId,
            redirectUrl: encodeURIComponent(redirectUrl),
        },
    });
    return api.post(path, {
        isServerless: true,
        data: {},
    });
};
export var kycFinancialContact = function (id, presignedUrlIdCardFront, presignedUrlIdCardBack) {
    return api.post("/financial-kyc/".concat(id), {
        isServerless: true,
        data: {
            uploadMethod: "presigned",
            IDCardFrontside: { preSignedUrl: presignedUrlIdCardFront },
            IDCardBackside: { preSignedUrl: presignedUrlIdCardBack },
        },
    });
};
export var deleteContact = function (id) { return api.delete("/contacts/".concat(id)); };
export var inviteContact = function (id) { return api.post("/contacts/".concat(id, "/invite")); };
export var payoutRentDeposit = function (contractId, ibanId) {
    return api.post("/contracts/rent-deposits/payout", {
        isServerless: true,
        data: {
            contractId: contractId,
            tenantBankAccountId: ibanId,
        },
    });
};
// The V2 { data } envelope is unwrapped here so callers keep receiving a plain axios
// response.
export var getContactBroker = function (brokerId, contactId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("/brokers/".concat(brokerId, "/contact/").concat(contactId), { isV2: true })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, __assign(__assign({}, response), { data: response.data.data })];
        }
    });
}); };
export var linkContact = function (contactId, data) {
    return api.post("/accounts/".concat(contactId, "/link-to-existing"), {
        data: data,
        isV2: true,
    });
};
export var askRemainingData = function (contactId) {
    return api.post("/contacts/".concat(contactId, "/ask-remaining-data"), {
        isV2: true,
    });
};
